module.exports = __webpack_public_path__ + "static/media/e_way_bill_logo.0be1ad61.png";